import aiFile from '../assets/aiFile.svg'
import csvFile from '../assets/csvFile.svg'
import defaultFile from '../assets/defaultFile.svg'
import docFile from '../assets/docFile.svg'
import emlFile from '../assets/emlFile.svg'
import exeFile from '../assets/exeFile.svg'
import gifFile from '../assets/gifFile.svg'
import icsFile from '../assets/icsFile.svg'
import imageFile from '../assets/imageFile.svg'
import pdfFile from '../assets/pdfFile.svg'
import psdFile from '../assets/psdFile.svg'
import recmanFile from '../assets/recmanFile.svg'
import videoFile from '../assets/videoFile.svg'
import xlsFile from '../assets/xlsFile.svg'
import zipFile from '../assets/zipFile.svg'

function getAttachmentPostV2Icon(typeDefault: string) {
    const type = (typeDefault ?? '').toLowerCase()
    switch (type) {
        case 'png':
        case 'jpg':
        case 'jpeg':
        case 'tif':
        case 'tiff':
        case 'jfif':
        case 'exif':
        case 'bpm':
        case 'ppm':
        case 'pgm':
        case 'pbm':
            return imageFile
        case 'pdf':
            return pdfFile
        case 'xls':
        case 'xlsx':
        case 'xlsm':
        case 'xlt':
            return xlsFile
        case 'doc':
        case 'dotx':
        case 'docx':
        case 'docm':
            return docFile
        case 'recman':
            return recmanFile
        case 'exe':
            return exeFile
        case 'ics':
            return icsFile
        case 'eml':
        case 'msg':
            return emlFile
        case 'csv':
        case 'p':
            return csvFile
        case 'ai':
            return aiFile
        case 'avi':
        case 'mp4':
        case 'mpeg':
        case 'fly':
        case 'mpg':
        case 'mkv':
        case '3gp':
        case 'mov':
            return videoFile
        case 'psd':
            return psdFile
        case 'gif':
            return gifFile
        case 'zip':
        case 'gzip':
        case '7z':
        case 'tar':
        case 'tgz':
        case 'cab':
        case 'rar':
            return zipFile
        default:
            return defaultFile
    }
}

export default getAttachmentPostV2Icon
